import { ReactNode } from 'react'
import { Trans } from 'next-i18next'
import { UiIcon } from '../Icon'

import Caption from 'modules/ui/atoms/Typography/Caption'
import Label from 'modules/ui/atoms/Typography/Label'

import { DEFAULT_THEME_COLORS } from 'css/theme'
import { withFullStoryUnmask } from 'utils/fullStory'
// TODO: Likely future work - getting theme from org settings
// import useThemeHook from 'utils/hooks/theme'

export interface InputContainerProps {
  value: string
  label?: string
  id: string
  placeholder?: string
  caption?: string
  captionId?: string
  hideErrorCaption?: boolean
  hideLabel?: boolean
  required?: boolean
  maxLength?: number
  hasOverflow?: boolean
  hasCounter?: boolean
  error?: string | boolean
  type?: string
  children?: ReactNode
}

type CaptionProps = {
  error?: string | boolean
  caption?: string
  captionId?: string
  maxLength?: number
  hasOverflow?: boolean
  hasCounter?: boolean
  valueLength?: number
}

export const InputCaption = ({
  error,
  caption,
  captionId,
  maxLength,
  hasOverflow,
  hasCounter,
  valueLength,
}: CaptionProps) => {
  const theme = DEFAULT_THEME_COLORS

  if (maxLength && valueLength && valueLength > maxLength && hasOverflow) {
    const extraCharacters = valueLength - maxLength

    return (
      <>
        {withFullStoryUnmask(
          <Caption id={captionId} errored={!!error} aria-live="assertive">
            <span aria-hidden="true">
              <UiIcon name="error" color={theme['--theme-color--status-error']} w={16} h={16} />
            </span>
            <Trans i18nKey="InputContainer.overLimit">
              You are {extraCharacters} character
              {extraCharacters > 1 ? 's' : ''} over the limit.
            </Trans>
          </Caption>,
        )}
        {withFullStoryUnmask(
          <Caption errored={!!error}>
            {valueLength}/{maxLength}
          </Caption>,
        )}
      </>
    )
  }

  if (error) {
    return withFullStoryUnmask(
      <Caption id={captionId} errored={!!error} aria-live="assertive">
        <span aria-hidden="true">
          <UiIcon
            aria-hidden="true"
            name="error"
            color={theme['--theme-color--status-error']}
            w={16}
            h={16}
          />
        </span>
        {error}
      </Caption>,
    )
  }

  return (
    <>
      {withFullStoryUnmask(<Caption id={captionId}>{caption}</Caption>)}

      {maxLength &&
        hasCounter &&
        withFullStoryUnmask(
          <Caption>
            {valueLength}/{maxLength}
          </Caption>,
        )}
    </>
  )
}

export const InputContainer = ({
  value,
  label,
  id,
  caption,
  captionId,
  hideErrorCaption,
  hideLabel,
  required,
  maxLength,
  hasOverflow = true,
  hasCounter = true,
  error,
  children,
}: InputContainerProps) => {
  return (
    <div>
      {!hideLabel &&
        !!label &&
        withFullStoryUnmask(
          <Label errored={!!error} size="sm" htmlFor={id} style={{ margin: '12px 0 0' }}>
            {label}
          </Label>,
        )}

      <div style={{ position: 'relative' }}>{children}</div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          margin: '0px 2px 4px',
        }}
      >
        {!hideErrorCaption && (
          <InputCaption
            error={error}
            caption={caption}
            captionId={captionId}
            valueLength={value ? value.length : 0}
            maxLength={maxLength}
            hasOverflow={hasOverflow}
            hasCounter={hasCounter}
          />
        )}
      </div>
    </div>
  )
}
